import { pxToRem } from "../../../utils/pxToRem";

export const clientsSectionHeading = {
  fontWeight: 500,
  fontSize: pxToRem(24),
  lineHeight: pxToRem(34),
  marginBottom: pxToRem(81),
};
